import logo from '../assets/logo.png'
import facebook from '../assets/facebook_icon.png'
import twitter from '../assets/twitter_icon.png'
import linkedIn from '../assets/linkedIn_icon.png'
import medium from '../assets/medium_icon.png'
import { BsGithub,BsFacebook,BsGoogle,BsLinkedin,BsInstagram} from 'react-icons/bs'

const Footer = () => (
  <div className="w-full flex md:justify-center justify-between items-center flex-col p-4 mt-30">
    <div className="w-full flex flex-col justify-between items-center my-4">
      {/* <div className="flex flex-row justify-center items-center mt-2">
            <ul className="flex flex-row justify-center space-x-2 mt-10 items-center my-4">
              <a
                className=" hover:scale-90 transition-all duration-75 delay-75 rounded-full mx-2"
                href="#"
              >
                <BsGithub className="text-black-600 text-2xl" />
              </a>
              <a
                className=" hover:scale-90 transition-all duration-75 delay-75 rounded-full mx-2"
                href="#"
              >
                <BsLinkedin className="text-black-600 text-2xl" />
              </a>
              
              <a
                className=" hover:scale-90 transition-all duration-75 delay-75 rounded-full mx-2"
                href="#"
              >
                <BsFacebook className="text-black-600 text-2xl" />
              </a>
              <a
                className=" hover:scale-90 transition-all duration-75 delay-75 rounded-full mx-2"
                href="#"
              >
                <BsGoogle className="text-black-600 text-2xl" />
              </a>
            </ul>
      </div> */}
      <div className="flex flex-row justify-center items-center mt-2">
        <img src={logo} alt="Spotization" className="w-8 mr-2" />
        <span className="text-white text-xs">
          Spotization © 2019 - 2023 With Love ❤️ <a href="https://spotiz.com/">Spotiz</a>   |   <a href="https://spotization.com/terms-and-conditions">Conditions générales de vente</a>
        </span>
      </div>
    </div>
  </div>
)
export default Footer